/** @jsxImportSource @emotion/react */
import { OTPInput, Typography, useTheme } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import { useActivateNewAuthenticator } from '../../api/authenticatorApi';

export const VerifyMfa = () => {
  const { spacing } = useTheme();
  const navigate = useNavigate();
  const [mfaCode, setMfaCode] = useState<string[]>(new Array(6).fill(''));
  const { mutateAsync: activateNewAuthenticator } =
    useActivateNewAuthenticator();
  const [{ error, loading }, onVerifyCode] = useAsyncFn(async () => {
    if (loading) return;
    const code = mfaCode.join('');
    try {
      const response = await activateNewAuthenticator(code);
      if (response.success) {
        void navigate('completed');
      }
    } finally {
      setMfaCode(new Array(6).fill(''));
    }
  }, [navigate, mfaCode]);

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: spacing.m,
        textAlign: 'center',
      }}
    >
      <div css={{ marginBottom: spacing.m }}>
        <Typography variant="heading2">
          Verify two-factor authenticator
        </Typography>
      </div>
      <Typography variant="body">
        Enter a 6 digit code from your two-factor authenticator app to make sure
        everything works.
      </Typography>
      <div css={{ marginTop: spacing.m, marginBottom: spacing.s }}>
        <OTPInput
          value={mfaCode}
          onChange={setMfaCode}
          error={error !== undefined}
          errorText="Two-factor authentication failed."
          onComplete={onVerifyCode}
        />
      </div>
    </div>
  );
};
